import TextField from '@components/v2/form/TextField/TextField';
import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Button from '@components/v2/ui/Button/Button';
import { Controller } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import { LoginPageTestIds } from '../../../../utils/testIds/LoginPage.testIds';
import { useTranslation } from '../../../translation/TranslationContext';
import useOAuthEmailForm, { OAuthEmailFormValues } from './hooks/useOAuthEmailForm';
import useOAuthEmailPanelStyles from './oauthEmailPanel.styles';

interface OAuthEmailPanelProps {
  onSubmit: (values: OAuthEmailFormValues) => Promise<void>;
}

const OAuthEmailPanel = ({ onSubmit }: OAuthEmailPanelProps) => {
  const { classes } = useOAuthEmailPanelStyles();
  const { translate } = useTranslation();
  const { form, handleSubmit } = useOAuthEmailForm({ onSubmit });

  return (
    <AuthPanel>
      <form onSubmit={handleSubmit} className={classes.form}>
        <Controller
          name="email"
          control={form.control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              type="email"
              autoComplete="email"
              label={translate(LangEnum.LOGIN_EMAIL)}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              slotProps={{ htmlInput: { 'test-id': LoginPageTestIds.LOGIN_EMAIL } }}
            />
          )}
        />
        <Button
          testId={LoginPageTestIds.OAUTH_EMAIL_CONTINUE_BUTTON}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth
          loading={form.formState.isSubmitting}
        >
          {translate(LangEnum.GLOBAL_CONTINUE)}
        </Button>
      </form>
    </AuthPanel>
  );
};

export default OAuthEmailPanel;
